import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs'
import {catchError} from 'rxjs/operators'; 
import { Router } from '@angular/router';
import { API_TOKEN } from '../utils/Constants';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(
        private router: Router
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if( !( 
            request.url.includes('Login') || 
            request.url.includes('.json') || 
            request.url.includes('ChangePassword') || 
            request.url.includes('Medios') || 
            request.url.includes('medios') 
        )) { 
            request = request.clone({
                setHeaders: {
                    'Authorization': API_TOKEN
                }
            });
        }
        return next.handle(request).pipe(
            catchError((response: HttpErrorResponse) => {
                if (response.status === 401) {
                    this.router.navigate(['/login']);
                }
                return throwError(response);
            }
            )
        )
    };
}